export default __webpack_public_path__ + "static/media/game-line-2.b4a5737a.png";